/* eslint-disable no-undef */
/* eslint-disable import/no-cycle */
import api from '../axios.service'

export default {
  getModel() {
    return api.get('/getModel')
  },
}
